import * as reduxForm from 'redux-form';

const SET_PRODUCT_CODE = 'gratis-app/SET_PRODUCT_CODE';

export default function reducer( state = '', action ) {
    switch ( action.type ) {
        case SET_PRODUCT_CODE:
            return action.product;
        default:
            return state;
    }
}

export function setProductCode( productCode ) {
    return ( dispatch, getState ) => {
        const st = getState();
        fetch( `${st.options.ws.base}/api/v1/${st.office.code}/products/${productCode}.json` )
            .then( function ( response ) {
                return response.json();
            } )
            .then( function ( json ) {
                if( ! json.product ){
                    throw json;
                }
                // XXX: gotta be a better way to add hidden/dynamic fields
                // XXX: hardcoded form name...again!
                dispatch( reduxForm.registerField( 'gratisForm', 'productCode', 'Field' ) );
                dispatch( reduxForm.registerField( 'gratisForm', 'g-recaptcha-response', 'Field' ) );
                dispatch( reduxForm.change( 'gratisForm', 'productCode', productCode ) );
                dispatch( {
                    type   : SET_PRODUCT_CODE,
                    product: json.product
                } );
            } )
            .catch( function ( ex ) {
                console.log(ex);
                dispatch( {
                    type   : SET_PRODUCT_CODE,
                    product: {
                        productcode: productCode,
                        error      : ex
                    }
                } );
            } );
    };
}



// WEBPACK FOOTER //
// ./src/form/redux/modules/product.js